import React, { useState } from 'react';
import { ChevronLeft, FileText, BookOpen, Newspaper, MonitorPlay, Printer, Home } from 'lucide-react';
import { InlinePdf } from './cursos/ProtectedMedia';

const DOCUMENTOS = [
  {
    id: 'guia-sustentante',
    title: 'Guía para el sustentante',
    date: '18 de junio de 2025',
    tag: 'Documento oficial',
    desc: 'La estructura completa del examen: áreas, número de reactivos, temarios, bibliografía de apoyo y ejemplos de reactivos de opción múltiple.',
    url: '/guias/guia-sustentante.pdf',
  },
  {
    id: 'folleto',
    title: 'Folleto EXANI-II',
    date: '24 de marzo de 2025',
    tag: 'Folleto informativo',
    desc: 'Información general del Examen Nacional de Ingreso a la Educación Superior: propósito, calificación y recomendaciones para el sustentante.',
    url: '/guias/folleto-exani-ii.pdf',
  },
  {
    id: 'guia-desde-casa',
    title: 'Guía de aplicación · Examen desde casa (2026)',
    date: 'Enero de 2026',
    tag: 'Guía de aplicación',
    desc: 'Todo sobre la modalidad desde casa: Navegador Seguro CENEVAL, requisitos del equipo, identificación, examen de práctica y comportamiento ético.',
    url: '/guias/guia-aplicacion-desde-casa.pdf',
  },
  {
    id: 'modalidad-linea',
    title: 'Modalidad de aplicación en línea (presencial)',
    date: 'Junio de 2025',
    tag: 'Guía de aplicación',
    desc: 'Aplicación en sedes institucionales con equipos de cómputo: requisitos de ingreso, material permitido y funcionamiento de la plataforma.',
    url: '/guias/modalidad-en-linea.pdf',
  },
  {
    id: 'modalidad-impresa',
    title: 'Modalidad de aplicación · Examen impreso',
    date: 'Junio de 2025',
    tag: 'Guía de aplicación',
    desc: 'Aplicación presencial con cuadernillo y hoja de respuestas: requisitos, material permitido e indicaciones para el llenado correcto.',
    url: '/guias/modalidad-impresa.pdf',
  },
];

const ICONOS = {
  'guia-sustentante': <BookOpen size={20} style={{ color: '#c5a059' }} />,
  'folleto': <Newspaper size={20} style={{ color: '#f87171' }} />,
  'guia-desde-casa': <Home size={20} style={{ color: '#38bdf8' }} />,
  'modalidad-linea': <MonitorPlay size={20} style={{ color: '#34d399' }} />,
  'modalidad-impresa': <Printer size={20} style={{ color: '#a78bfa' }} />,
};

const DocumentosCeneval = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
      {/* Encabezado */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '22px',
        paddingBottom: '16px', borderBottom: '1px solid rgba(197,160,89,0.2)',
        flexWrap: 'wrap',
      }}>
        <div style={{
          width: '46px', height: '46px', borderRadius: '12px', flexShrink: 0,
          background: 'rgba(197,160,89,0.12)', border: '1px solid rgba(197,160,89,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <FileText size={22} style={{ color: '#c5a059' }} />
        </div>
        <div style={{ flex: 1, minWidth: '220px' }}>
          <h2 style={{
            margin: '0', fontFamily: "'Orbitron', sans-serif", fontSize: '0.95rem',
            fontWeight: 700, color: '#c5a059', letterSpacing: '1.5px', textTransform: 'uppercase',
          }}>
            Documentos Oficiales CENEVAL
          </h2>
          <span style={{ fontSize: '0.72rem', color: 'rgba(181,200,216,0.65)' }}>
            Guías y folleto oficiales del EXANI-II · Acceso solo lectura (sin descarga)
          </span>
        </div>
        <span style={{
          fontSize: '0.62rem', fontFamily: "'Orbitron', sans-serif", letterSpacing: '1px',
          color: '#c5a059', background: 'rgba(197,160,89,0.1)', border: '1px solid rgba(197,160,89,0.25)',
          padding: '5px 10px', borderRadius: '20px', textTransform: 'uppercase',
        }}>
          © CENEVAL
        </span>
      </div>

      {!selected ? (
        <>
          <p style={{ fontSize: '0.82rem', color: 'rgba(181,200,216,0.7)', lineHeight: 1.7, margin: '0 0 20px' }}>
            Material oficial del Centro Nacional de Evaluación para la Educación Superior. Selecciona un
            documento para consultarlo en pantalla. Los archivos se muestran <strong style={{ color: '#c5a059' }}>solo lectura</strong>:
            no incluyen botón de descarga ni enlace directo al archivo.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {DOCUMENTOS.map((doc) => (
              <button
                key={doc.id}
                type="button"
                onClick={() => setSelected(doc)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '14px', textAlign: 'left', cursor: 'pointer',
                  background: 'rgba(10,26,42,0.75)', border: '1px solid rgba(197,160,89,0.18)',
                  borderLeft: '3px solid rgba(197,160,89,0.55)', borderRadius: '10px',
                  padding: '14px 16px', transition: 'all 0.25s ease', width: '100%',
                  fontFamily: "'Inter', sans-serif", color: '#e2e8f0',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(197,160,89,0.5)';
                  e.currentTarget.style.background = 'rgba(13,32,53,0.9)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(197,160,89,0.18)';
                  e.currentTarget.style.background = 'rgba(10,26,42,0.75)';
                }}
              >
                <div style={{
                  width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0,
                  background: 'rgba(7,21,38,0.7)', border: '1px solid rgba(197,160,89,0.15)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  {ICONOS[doc.id]}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '0.88rem', fontWeight: 700, color: '#f1f5f9' }}>{doc.title}</span>
                    <span style={{
                      fontSize: '0.58rem', fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase',
                      color: '#0d2035', background: 'rgba(197,160,89,0.75)',
                      padding: '2px 7px', borderRadius: '10px',
                    }}>
                      {doc.tag}
                    </span>
                  </div>
                  <p style={{ margin: '4px 0 0', fontSize: '0.76rem', color: 'rgba(181,200,216,0.7)', lineHeight: 1.5 }}>
                    {doc.desc}
                  </p>
                  <span style={{ fontSize: '0.64rem', color: '#64748b', marginTop: '3px', display: 'block' }}>
                    Actualizado: {doc.date}
                  </span>
                </div>
                <span style={{
                  flexShrink: 0, fontSize: '0.62rem', fontWeight: 700, letterSpacing: '1px',
                  textTransform: 'uppercase', color: '#c5a059', border: '1px solid rgba(197,160,89,0.35)',
                  padding: '6px 12px', borderRadius: '20px', background: 'rgba(197,160,89,0.08)',
                  fontFamily: "'Orbitron', sans-serif",
                }}>
                  Leer PDF
                </span>
              </button>
            ))}
          </div>

          <p style={{ fontSize: '0.68rem', color: '#475569', lineHeight: 1.6, marginTop: '18px', textAlign: 'center' }}>
            El EXANI-II es un instrumento del CENEVAL. Este material se muestra con fines de orientación y
            estudio. Conoce más en <strong style={{ color: '#64748b' }}>ceneval.edu.mx</strong>.
          </p>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={() => setSelected(null)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer',
                background: 'rgba(197,160,89,0.1)', border: '1px solid rgba(197,160,89,0.3)',
                borderRadius: '8px', color: '#c5a059', fontSize: '0.7rem', fontWeight: 700,
                padding: '8px 14px', fontFamily: "'Orbitron', sans-serif", letterSpacing: '1px',
                textTransform: 'uppercase',
              }}
            >
              <ChevronLeft size={14} /> Volver
            </button>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <span style={{ display: 'block', fontSize: '0.88rem', fontWeight: 700, color: '#f1f5f9' }}>
                {selected.title}
              </span>
              <span style={{ fontSize: '0.66rem', color: '#64748b' }}>
                {selected.tag} · Solo lectura · CENEVAL
              </span>
            </div>
          </div>
          <InlinePdf url={selected.url} name={selected.title} />
        </>
      )}
    </div>
  );
};

export default DocumentosCeneval;